class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    const isCartPage = document.querySelector("cart-items");
    if (isCartPage) return;
    // Панель уже открыта (например, товар добавлен из блока «Add more to your
    // purchase» внутри неё): повторный запуск только навесил бы второй
    // обработчик transitionend и сбросил бы фокус.
    if (this.classList.contains("active")) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer-inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer-inner") ||
          this.querySelector(".drawer-close");
        if (containerToTrapFocusOn) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );
    document.body.classList.add("cart-drawer-quick-view");
   if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "hidden";
    document.body.style.padding = "0 4px 0 0";
   }
    const animatedElements = this.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      element.classList.add("aos-animate");
    });
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-drawer-quick-view");
    if (window.matchMedia("(min-width: 768px)").matches) {
    document.body.style.overflow = "scroll";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
    }
    const animatedElements = this.querySelectorAll(".aos-animate");
    animatedElements.forEach((element) => {
      element.classList.remove("aos-animate");
    });
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer-inner");
    const wasEmpty = drawerInner && drawerInner.classList.contains("is-empty");
    const wasDrawerEmpty = this.classList.contains("is-empty");
    // Remove is-empty class from both drawer-inner and cart-drawer element itself
    if (wasEmpty) {
      drawerInner.classList.remove("is-empty");
    }
    if (wasDrawerEmpty) {
      this.classList.remove("is-empty");
    }
    
    // productId is optional - only exists in /cart/add.js response, not in /cart?sections=... response
    if (parsedState.id) {
      this.productId = parsedState.id;
    }
    
    const sectionsToRender = this.getSectionsToRender();
    sectionsToRender.forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) {
        console.warn('[CART-DEBUG] Section element not found:', section.id || section.section, 'selector:', section.selector);
        return;
      }
      const sectionData = parsedState.sections?.[section.id];
      if (!sectionData) {
        console.warn('[CART-DEBUG] Section data not found:', section.id || section.section);
        return;
      }
      // For cart-drawer section, we need to extract the inner content of #CartDrawer
      // API returns HTML wrapped in .shopify-section, but we need the content of #CartDrawer inside
      let innerHTML;
      if (section.id === 'cart-drawer' || section.section === 'cart-drawer') {
        // Parse the section HTML and find #CartDrawer inside
        const parsedHTML = new DOMParser().parseFromString(sectionData, 'text/html');
        const cartDrawerElement = parsedHTML.querySelector('#CartDrawer');
        if (cartDrawerElement) {
          innerHTML = cartDrawerElement.innerHTML;
        } else {
          // Fallback: try to find .shopify-section and extract its content
          const shopifySection = parsedHTML.querySelector('.shopify-section');
          if (shopifySection) {
            innerHTML = shopifySection.innerHTML;
          } else {
            // Last resort: use the raw HTML
            innerHTML = sectionData;
          }
        }
      } else {
        // For other sections, use the standard method
        innerHTML = this.getSectionInnerHTML(sectionData, section.selector);
      }
      sectionElement.innerHTML = innerHTML;
    });
    setTimeout(() => {
      const overlay = this.querySelector("#CartDrawer-Overlay");
      if (overlay) {
        overlay.addEventListener(
          "click",
          this.close.bind(this)
        );
      }
      // Открывать панель сразу после добавления товара (просьба клиента,
      // 14.09.2026): одной цифры на иконке покупателям мало, чтобы понять,
      // что товар в корзине. renderContents вызывается только из потоков
      // добавления (product-form, Globo, quick add), изменение количества
      // внутри панели идёт через cart-drawer-items и сюда не попадает.
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer-inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
